import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location, DecimalPipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { ApiService, MetadataService } from '../../../ubi-core/ubi-core.module';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes } from 'ngx-uploader';

import { UbiFilterService } from '../../../theme';
import { AnnouncementService } from './announcement.service';
import { environment } from '../../../../environments/environment';
import { WeightPipe } from '../../../ubi-core/pipes/WeightPipe';

import { Subject } from 'rxjs/Subject';

interface FormData {
  concurrency: number;
  autoUpload: boolean;
  verbose: boolean;
}

const API_URL = environment.apiUrl;

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss']
})
export class AnnouncementComponent implements OnInit, AfterViewInit {

  @ViewChild('batchUpdateTmpl') batchUpdateTmpl: TemplateRef<any>;
  @ViewChild('hdrTpl') hdrTpl: TemplateRef<any>;
  @ViewChild('actionsTmpl') actionsTmpl: TemplateRef<any>;
  @ViewChild('statusTmpl') statusTmpl: TemplateRef<any>;
  @ViewChild('statusLoadVesselTmpl') statusLoadVesselTmpl: TemplateRef<any>;
  @ViewChild('cancelTmpl') cancelTmpl: TemplateRef<any>;
  @ViewChild('deleteItemsTmpl') deleteItemsTmpl: TemplateRef<any>;
  @ViewChild('filterTmpl') filterTmpl: TemplateRef<any>;
  @ViewChild('setColumnsTmpl') setColumnsTmpl: TemplateRef<any>;
  @ViewChild('logTmpl') logTmpl: TemplateRef<any>;
  @ViewChild('uploadFile') uploadFile: any;
  @ViewChild('uploadFileUpdate') uploadFileUpdate: any;

  private entity = 'announcements';
  private announcement: any = null;
  private announcementId: number = null;
  private announcementItems: any[];
  private announcementItemsToShow: Array<any> = new Array<any>();
  private loading = false;
  private uploadForm: FormGroup;
  private announcementForm: FormGroup;
  private associateForm: FormGroup;
  private editItemForm: FormGroup;
  private ships = [];
  private seaportCustomers = [];
  private customers = [];
  private productTypes = [];
  private zones = [];
  private truckingCompanies = [];
  private templates = [];
  private visibility = {
    uploadFile: false,
    detail: false,
    items: false
  };
  private currentFilter: any = null;

  private columns = [];
  private selectedColumns = [];
  private selected = [];
  private deleted = [];
  private filters = [];

  private formData: FormData;
  private files: UploadFile[];
  private uploadInput: EventEmitter<UploadInput>;
  private humanizeBytes: Function;
  private dragOver: boolean;
  private options: any;
  private errorMessage: string = null;
  private log: string = null;
  private shipDesignation = '';
  private shipProcess = '';
  private shipName = '';
  private shipEntryDate = null;
  private processing = false;
  private previousVesselAndProcessID = null;
  private totalMovs:number = 0;

  private status = {
    canDelete: false,
    canSave: false
  };

  constructor(private router: Router, private route: ActivatedRoute, private baseservice: ApiService,
    private modalService: NgbModal, private fb: FormBuilder, private announcementservice: AnnouncementService,
    private location: Location, private toastr: ToastrService, private filterservice: UbiFilterService) {
    this.files = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;

    this.formData = {
      concurrency: 1,
      autoUpload: false,
      verbose: true
    };
  }

  ngOnInit() {

    const id = +this.route.snapshot.params['id'];

    this.columns = [
      {
        headerCheckboxable: true, checkboxable: true, width: 30, sortable: false, canAutoResize: false,
        draggable: false, resizeable: false, frozenLeft: true
      },
      {
        prop: 'StatusID', name: 'Estado', width: 35, canAutoResize: false, draggable: false, resizeable: false,
        headerTemplate: this.hdrTpl, cellTemplate: this.statusTmpl, cellClass: 'icon-column', headerClass: 'icon-column',
        frozenLeft: true
      },
      {
        prop: 'ItemRelatedID', name: 'Estado', width: 35, canAutoResize: false, draggable: false, resizeable: false,
        headerTemplate: this.hdrTpl, cellTemplate: this.statusLoadVesselTmpl, cellClass: 'icon-column', headerClass: 'icon-column',
        frozenLeft: true
      },
      { prop: 'ProductCode', name: 'Código', frozenLeft: true, draggable: false },
      { prop: 'ProductName', name: 'Produto' },
      { prop: 'Zone.Designation', name: 'Zona' },
      { prop: 'Lot', name: 'Lote' },
      { prop: 'ProductType.Designation', name: 'Tipo de Produto' },
      { prop: 'NetSize.Lenght', name: 'Comp. Líq.', width: 75, cellClass: 'text-right' },
      { prop: 'NetSize.Width', name: 'Larg. Líq.', width: 75, cellClass: 'text-right' },
      { prop: 'NetSize.Thickness', name: 'Esp. Líq.', width: 75, cellClass: 'text-right' },
      { prop: 'NetWeight', name: 'Peso Líq.', width: 75, cellClass: 'text-right', pipe: new WeightPipe('en', '1.3-3') },
      { prop: 'GrossSize.Lenght', name: 'Comp. Br.', width: 75, cellClass: 'text-right' },
      { prop: 'GrossSize.Width', name: 'Larg. Br.', width: 75, cellClass: 'text-right' },
      { prop: 'GrossSize.Thickness', name: 'Esp. Br.', width: 75, cellClass: 'text-right' },
      { prop: 'GrossWeight', name: 'Peso Br.', width: 75, cellClass: 'text-right', pipe: new WeightPipe('en', '1.3-3') },
      { prop: 'PlateCount', name: 'Contagem', width: 50, cellClass: 'text-right' },
      { prop: 'SoldTo.Designation', name: 'Consignatário' },
      { prop: 'ShipTo.Designation', name: 'Destinatário' },
      { prop: 'Quality', name: 'Qualidade' },
      { prop: 'Obs', name: 'Obs.' },
      {
        prop: 'Id', width: 60, sortable: false, canAutoResize: false, draggable: false, resizeable: false, cellTemplate: this.actionsTmpl,
        headerTemplate: this.hdrTpl, frozenRight: true
      }
    ];

    // By defaull, set all columns to visible
    this.columns.forEach(c => c.visible = true);

    this.selectedColumns = Object.assign(this.selectedColumns, this.columns);

    this.uploadForm = this.fb.group({
      TypeID: [null, Validators.required],
      SeaportCustomerID: null,
      CustomerID: [null, Validators.required],
      TemplateID: null,
      AnnouncementID: null,
    });

    this.announcementForm = this.fb.group({
      TypeID: [null, Validators.required],
      SeaportCustomerID: null,
      CustomerID: [null, Validators.required],
      Community: null,
      VesselAndProcessIDFromView: null,
      PortOfLoading: null,
      PortOfDischarge: null
    });

    this.associateForm = this.fb.group({
      lot: null,
      zone: null,
      productType: null,
      soldTo: null,
      shipTo: null
    });

    this.editItemForm = this.fb.group({
      Lot: null,
      ZoneID: null,
      ProductTypeID: null,
      ProductCode: [null, Validators.required],
      ProductName: null,
      NetWeight: null,
      GrossWeight: null,
      NetSize: this.fb.group({ Length: null, Width: null, Thickness: null }),
      GrossSize: this.fb.group({ Length: null, Width: null, Thickness: null }),
      Quality: null,
      PlateCount: null,
      SoldToID: null,
      ShipToID: null,
      Obs: null
    });

    this.filters = [{
      id: 'StatusID',
      label: 'Tipo Mov',
      type: 'integer'
    },
    {
      id: 'ProductCode',
      label: 'Código de Produto',
      type: 'string'
    },
    {
      id: 'ProductName',
      label: 'Produto',
      type: 'string'
    },
    {
      id: 'Zone.Designation',
      label: 'Zona',
      type: 'string'
    },
    {
      id: 'Lot',
      label: 'Lote',
      type: 'string'
    },
    {
      id: 'ProductType.Designation',
      field: 'ProductType.Designation',
      label: 'Tipo de Produto',
      type: 'string'
    },
    {
      id: 'NetSize.Lenght',
      label: 'Comprimento Líquido',
      type: 'double'
    },
    {
      id: 'NetSize.Width',
      label: 'Largura Líquida',
      type: 'double'
    },
    {
      id: 'NetSize.Thickness',
      label: 'Espessura Líquida',
      type: 'double'
    },
    {
      id: 'NetWeight',
      label: 'Peso Líquido',
      type: 'double'
    },
    {
      id: 'GrossSize.Lenght',
      label: 'Comprimento Bruto',
      type: 'double'
    },
    {
      id: 'GrossSize.Width',
      label: 'Largura Bruta',
      type: 'double'
    },
    {
      id: 'GrossSize.Thickness',
      label: 'Espessura Bruta',
      type: 'double'
    },
    {
      id: 'GrossWeight',
      label: 'Peso Bruto',
      type: 'double'
    },
    {
      id: 'PlateCount',
      label: 'Contagem',
      type: 'integer'
    },
    {
      id: 'SoldTo.Designation',
      label: 'Consignatário',
      type: 'string'
    },
    {
      id: 'ShipTo.Designation',
      label: 'Destinatário',
      type: 'string'
    },
    {
      id: 'Quality',
      label: 'Qualidade',
      type: 'string'
    },
    {
      id: 'Obs',
      label: 'Observações',
      type: 'string'
    }    
    ];

    this.getInitialData(id);

    this.getCustomers();
    this.getProductTypes();
    this.getZones();
    this.getTruckingCompanies();
    this.getTotalMovs(id);
  }
  
  
  private getInitialData(id: number) {

    this.baseservice.setEntity(this.entity);

    if (!isNaN(id) && id !== null && id !== undefined) {
      this.loading = true;
      this.visibility.detail = true;
      this.visibility.items = true;
      this.baseservice.getById(id)
        .subscribe(return_value => {
          this.announcement = return_value;
          this.announcementForm.patchValue(this.announcement);
          this.announcementItems = this.announcement.AnnouncementItems;
          this.announcementItemsToShow = this.announcement.AnnouncementItems;
          this.uploadForm.patchValue({
            SeaportCustomerID: this.announcement.SeaportCustomerID,
            CustomerID: this.announcement.CustomerID,
            TypeID: this.announcement.TypeID,
            TemplateID: this.announcement.CustomerID,
            AnnouncementID: this.announcement.Id
          });
          this.previousVesselAndProcessID = this.announcement.VesselAndProcessID;
          // Can delete if don't exist any item with movement (Status 3 or 4)
          this.status.canDelete = this.announcement.AnnouncementItems.filter(i => i.StatusID === 3 || i.StatusID === 4).length === 0;

          // Load vessels by announcement type
          this.getVessesAndProcesses();
          // If LoadVessel show alert if item unmatch UnloadTrack item
          if (this.announcement.TypeID !== 2) {
            this.columns = this.columns.filter(c => {
              return c.prop !== 'ItemRelatedID';
            });
            this.selectedColumns = this.selectedColumns.filter(c => {
              return c.prop !== 'ItemRelatedID';
            });
          }
          this.loading = false;
        }, error => console.error('Error fetching: ' + error));
    } else {
      this.announcement = null;
      this.announcementItems = [];
      this.announcementItemsToShow = [];
      this.visibility.uploadFile = true;
      this.status.canDelete = false;
    }
  }

  ngAfterViewInit() {
    let previousValid = this.announcementForm.valid;

    this.uploadForm.valueChanges.subscribe(() => {
      if (this.uploadForm.valid !== previousValid) {
        previousValid = this.uploadForm.valid;
        this.status.canSave = previousValid;
      }
    });

    this.announcementForm.valueChanges.subscribe(() => {
      if (this.announcementForm.valid !== previousValid) {
        previousValid = this.announcementForm.valid;
        this.status.canSave = previousValid;
      }
    });

    this.status.canSave = previousValid;
  }

  onUploadOutput(output: UploadOutput): void {

    this.log = null;

    if (output.type === 'allAddedToQueue') {
      const event: UploadInput = {
        type: 'uploadAll',
        url: API_URL + '/Announcements/Upload',
        method: 'POST',
        data: this.uploadForm.value,
        concurrency: this.formData.concurrency
      };
      this.errorMessage = null;
      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      this.files.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;

      this.modalService.open(this.logTmpl, { backdrop: 'static', keyboard: false }).result.then((result) => {

        if (output.file.responseStatus === 200 && result === 'Ok') {
          if (this.announcement === null) {
            this.router.navigateByUrl(this.router.url + '/' + this.announcementId);
          } else {
            this.getInitialData(this.announcement.Id);
          }
        } else {
          // Não faz nada quando se cancela
        }

      });



    } else if (output.type === 'removed') {
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'done') {

      if (output.file.responseStatus === 200) {
        this.announcementId = output.file.response.Id;
      } else {
        this.errorMessage = 'Não foi possível importar o ficheiro, verifique se o ficheiro segue a definição do template.';
        this.files = [];
      }
      this.log = output.file.response.Log;

      this.uploadFile.nativeElement.value = '';
      this.uploadFileUpdate.nativeElement.value = '';

    }
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  public filterSelectedColumns() {
    return this.columns.filter(c => c.draggable === null || c.draggable === true)
  }

  public cancel(event) {

    this.modalService.open(this.cancelTmpl, { backdrop: 'static', keyboard: false }).result.then((result) => {
      if (result === 'Save') {
        this.save();
        this.router.navigateByUrl('backoffice/announcements');
      } else if (result === 'Discard') {
        this.router.navigateByUrl('backoffice/announcements');
      } else {
        // Não faz nada quando se cancela
      }
    });

  }
  
 //GA - 2024-07-18
  public getTotalAnnounces (){
    return this.announcementItemsToShow.length;
  };  

  public getTotalMovs (id: number){
    console.log(id);
    this.baseservice.setEntity('Movements/GetTotalMovs?announceId='+ id);
    this.baseservice.getAll().subscribe(data => this.totalMovs = data);    
  };  


  public customerChange(id) {
    this.announcementservice.getTemplates(id).subscribe(
      data => {
        this.templates = data;
        this.uploadForm.patchValue({ TemplateID: null });
      }
    );
  }

  private getVessesAndProcesses() {
    this.baseservice.setEntity('VesselAndProcesses/GetActiveVesselAndProcesses?movementType=' +
      this.announcement.TypeID);
    this.baseservice.getAll().subscribe(
      data => this.ships = data);
  }

  private getCustomers() {
    this.baseservice.setEntity('Customers');
    this.baseservice.getPage({ 'pageSize': 300, 'sortAsString': 'Designation' }).subscribe(
      data => {
        this.customers = data.data;
      });

    this.baseservice.setEntity('Customers/GetSeaportCustomers');
    this.baseservice.getAll().subscribe(
      data => {
        this.seaportCustomers = data;
    });
  }

  private getProductTypes() {
    this.baseservice.setEntity('ProductTypes');
    this.baseservice.getAll().subscribe(
      data => this.productTypes = data);
  }

  private getZones() {
    this.baseservice.setEntity('Zones');
    this.baseservice.getAll().subscribe(
      data => this.zones = data);
  }

  private getTruckingCompanies() {
    this.baseservice.setEntity('TruckingCompanies');
    this.baseservice.getAll().subscribe(
      data => this.truckingCompanies = data);
  }

  public deleteSelected() {

    this.modalService.open(this.deleteItemsTmpl, { backdrop: 'static', keyboard: false }).result.then((result) => {
      if (result === 'Delete') {
        const cloned = this.selected.map(x => Object.assign({}, x));
        cloned.forEach(element => {
          this.deleted.push(element);
        });

        this.selected.forEach(element => {
          this.announcementItems = this.announcementItems.filter(a => a.Id !== element.Id);
        });
        this.announcementItems = [...this.announcementItems];
        this.updateItemsToShow();

      } else {
        // Não faz nada quando se cancela
      }
    });

  }

  public openFilter(event) {

    this.modalService.open(this.filterTmpl, { backdrop: 'static', keyboard: false, size: 'lg' }).result.then((result) => {
      if (result === 'Save') {
        this.currentFilter = this.filterservice.getCurrentFilter();

        const filter = this.filterservice.getCurrentFilterAsExpression(this.currentFilter);

        this.announcementItemsToShow = this.announcementItems.filter(filter);

      } else {
        // Não faz nada quando se cancela
      }
    });

  }

  public eraseFilter(event) {
    this.currentFilter = null;
    this.announcementItemsToShow = [...this.announcementItems];
  }

  public newItem(event, content) {

    this.editItemForm.reset();

    this.modalService.open(content, { backdrop: 'static', keyboard: false, size: 'lg' }).result.then((result) => {
      if (result === 'Save') {

        this.editItemForm.value.announcementId = this.announcement.Id;
        this.announcementItems.push(this.editItemForm.value);
        this.updateItemsToShow();

      } else {
        // Não faz nada quando se cancela
      }
    });

  }

  private onShipChange(event: Event): void {

    const shipDropdown = <HTMLSelectElement>event.target;
    this.shipProcess = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-process');
    this.shipDesignation = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-designation');
    this.shipName = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-name');
    this.shipEntryDate = shipDropdown.options[shipDropdown.selectedIndex].getAttribute('data-entry-date');
  }

  public createOrSave(event) {
    if (this.announcement !== null) {
      this.save();
    } else {

      this.announcementservice.new(this.uploadForm.value)
        .subscribe(return_value => {
          this.router.navigateByUrl(this.router.url + '/' + return_value.Id);

        },
        error => {
          this.errorMessage = 'Ocorreu um erro a gravar ' + error;
          console.error('Error saving ' + this.entity + ' ' + error);
        });

    }
  }

  public save() {

    this.processing = true;

    const formModel = this.announcementForm.value;
    this.announcement = Object.assign(this.announcement, formModel);

    this.announcement.Process = this.shipProcess;
    this.announcement.VesselAndProcessDescriptionFromView = this.shipDesignation;
    this.announcement.VesselAndProcessNameFromView = this.shipName;
    this.announcement.VesselAndProcessEntryDateFromView = this.shipEntryDate;

    delete this.announcement.Customer;
    delete this.announcement.Type;
    delete this.announcement.VesselAndProcesses;
    delete this.announcement.TruckingCompany;

    this.announcement.AnnouncementItems.forEach(element => {
      delete element.Status;
      delete element.ProductType;
      delete element.Zone;
      delete element.SoldTo;
      delete element.ShipTo;

    });

    this.announcementservice.save(this.announcement.Id,
      { 'Announcement': this.announcement,
        'AnnouncementItems2Delete': this.deleted,
        'PreviousVesselAndProcessID': this.previousVesselAndProcessID })
      .subscribe(return_value => {
        this.refreshAnnouncement(return_value, 'Gravação efectuada com sucesso');
        this.errorMessage = null;
      },
      error => {
        this.processing = false;
        this.errorMessage = 'Ocorreu um erro a gravar ' + error;
        console.error('Error saving ' + this.entity + ' ' + error);
      });
  }

  public delete() {
    this.announcementservice.delete(this.announcement.Id)
      .subscribe(return_value => {
        this.toastr.success('Anúncio apagado com sucesso', '', { timeOut: 3000 });
        this.router.navigateByUrl('backoffice/announcements');
      },
      error => {
        this.errorMessage = 'Ocorreu um erro a apagar ' + error;
        console.error('Error deleting ' + this.entity + ' ' + error);
      });
  }

  public editItem(item, content) {

    this.editItemForm.patchValue(item);

    this.modalService.open(content, { backdrop: 'static', keyboard: false, size: 'lg' }).result.then((result) => {
      if (result === 'Save') {

        const itemToUpdate = this.announcementItems.find(a => a.Id === item.Id);
        Object.assign(itemToUpdate, this.editItemForm.value);
        itemToUpdate.ProductType = this.productTypes.find(p => p.Id === +itemToUpdate.ProductTypeID);
        itemToUpdate.Zone = this.zones.find(p => p.Id === +itemToUpdate.ZoneID);
        itemToUpdate.SoldTo = this.customers.find(c => c.Id === +itemToUpdate.SoldToID);
        itemToUpdate.ShipTo = this.customers.find(c => c.Id === +itemToUpdate.ShipToID);

        this.announcementItems = [...this.announcementItems];
        this.updateItemsToShow();

      } else {
        // Não faz nada quando se cancela
      }
    });

  }

  public setColumns(event): void {

    this.modalService.open(this.setColumnsTmpl, { backdrop: 'static', keyboard: false }).result.then((result) => {
      if (result === 'Save') {
        this.selectedColumns = this.columns.filter(c => c.visible === true || c.draggable === false);
        this.selectedColumns = [...this.selectedColumns];
      }
    });

  }

  public setAllChecked(checkAll): void {
    this.columns.forEach(c => c.visible = checkAll);
  }

  public setAditionalInfo(event): void {

    this.associateForm.reset();

    this.modalService.open(this.batchUpdateTmpl, { backdrop: 'static', keyboard: false }).result.then((result) => {
      if (result === 'Save') {

        this.selected.forEach(element => {
          const itemToUpdate = this.announcementItems.find(a => a.Id === element.Id);

          if (this.associateForm.value.lot !== null && this.associateForm.value.lot !== undefined) {
            itemToUpdate.Lot = this.associateForm.value.lot;
          }

          if (this.associateForm.value.zone !== null && this.associateForm.value.zone !== undefined) {
            itemToUpdate.ZoneID = this.associateForm.value.zone;
            itemToUpdate.Zone = this.zones.find(p => p.Id === +itemToUpdate.ZoneID);
          }

          if (this.associateForm.value.productType !== null && this.associateForm.value.productType !== undefined) {
            itemToUpdate.ProductTypeID = this.associateForm.value.productType;
            itemToUpdate.ProductType = this.productTypes.find(p => p.Id === +itemToUpdate.ProductTypeID);
          }

          if (this.associateForm.value.soldTo !== null && this.associateForm.value.soldTo !== undefined) {
            itemToUpdate.SoldToID = this.associateForm.value.soldTo;
            itemToUpdate.SoldTo = this.customers.find(c => c.Id === +itemToUpdate.SoldToID);
          }

          if (this.associateForm.value.shipTo !== null && this.associateForm.value.shipTo !== undefined) {
            itemToUpdate.ShipToID = this.associateForm.value.shipTo;
            itemToUpdate.ShipTo = this.customers.find(c => c.Id === +itemToUpdate.ShipToID);
          }

        });
        this.announcementItems = [...this.announcementItems];
        this.updateItemsToShow();

      } else {
        // Não faz nada quando se cancela
      }
    });
  }

  private updateItemsToShow() {
    if (this.currentFilter !== null) {
      const filter = this.filterservice.getCurrentFilterAsExpression(this.currentFilter);
      this.announcementItemsToShow = this.announcementItems.filter(filter);
      this.announcementItemsToShow = [...this.announcementItemsToShow];
    } else {
      this.announcementItemsToShow = [...this.announcementItems];
    }
  }


  private refreshAnnouncement(return_value: any, mensagem: string) {
    this.toastr.success(mensagem, '', { timeOut: 3000 });
    this.announcement = return_value;
    this.announcementForm.patchValue(this.announcement);
    this.announcementItems = this.announcement.AnnouncementItems;
    this.announcementItemsToShow = this.announcement.AnnouncementItems;
    this.processing = false;
    this.previousVesselAndProcessID = this.announcement.VesselAndProcessID;
  }

  private excelClick() {
    this.processing = true;
    this.baseservice.setEntity('AnnouncementItems/ExportToExcel?announcementId=' + this.announcement.Id);
    this.baseservice.getFile(null, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet').subscribe(return_value => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(return_value);
      link.download = 'AnnouncementItems.xlsx';
      link.click();
    },
      error => {
        this.processing = false;
        console.log('Error exporting to excel' + error);
      },
      () => {
        this.processing = false;
        console.log('Completed file download.');
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/announcements/announcement.component.ts